export default "__VITE_ASSET__DLjJZHqJ__"